import { Component, OnInit } from '@angular/core';
import { EventEmitterService } from 'src/app/shared/services/event.emitter.service';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {

  categories: {name: string, route: string, figPath: string}[] = [
    {name: "categoriesName.all", route: "#", figPath: "/assets/icons/Categories/svg/allcategories.svg"},
    {name: "categoriesName.humans", route: "#", figPath: "/assets/icons/Categories/svg/cat-humans.svg"},
    {name: "categoriesName.animals", route: "#", figPath: "/assets/icons/Categories/svg/cat-animals.svg"},
    {name: "categoriesName.insects", route: "#", figPath: "/assets/icons/Categories/svg/cat-insects.svg"},
    {name: "categoriesName.nature", route: "#", figPath: "/assets/icons/Categories/svg/cat-nature.svg"},
    {name: "categoriesName.science", route: "#", figPath: "/assets/icons/Categories/svg/science.svg"},
    {name: "categoriesName.health", route: "#", figPath: "/assets/icons/Categories/svg/health.svg"},
  ];

  categoriesMap: Map<string,string>;

  constructor(private eventEmitterService: EventEmitterService) { }

  ngOnInit(): void {
    this.categoriesMap = new Map<string, string>();

    this.categoriesMap.set("categoriesName.all", "All");
    this.categoriesMap.set("categoriesName.humans", "Humans"); 
    this.categoriesMap.set("categoriesName.animals", "Animals");
    this.categoriesMap.set("categoriesName.insects", "Insects");
    this.categoriesMap.set("categoriesName.nature", "Nature");
    this.categoriesMap.set("categoriesName.science", "Science");
    this.categoriesMap.set("categoriesName.health", "Health");
  }

  setStorybookCategory(storybookCategory){
    let storyBookCat = this.categoriesMap.get(storybookCategory);
    this.eventEmitterService.changeStoryBookCategoryEvent(storyBookCat);
  }

}
